import { Fragment, useState, useContext, useEffect } from "react";

import DataContext from "../../context/data-context";
import { requestPartnerAPI } from "../../api/server";
import LoadingSpinnerWrapper from "../UI/LoadingSpinnerWrapper";
import Heading from "../UI/Heading";
import { MdRefresh } from "react-icons/md";
import VehiclesRevenue from "../vehicles/VehiclesRevenue";
import Notification from "./Notification";
import { UtilityContext } from "../../context/util-context";

export default function General() {
  const { partner, fetchData } = useContext(DataContext);
  const { navigate } = useContext(UtilityContext);
  const [vehicles, setVehicles] = useState();
  const [loading, setLoading] = useState(true);

  // ============================================= FETCH VEHICLES
  const fetchVehicles = async () => {
    try {
      setLoading(true);
      const response = await requestPartnerAPI("fetch-vehicles", {
        limit: null,
      });
      setVehicles(response);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVehicles();
  }, []);

  return (
    <div className="grid content-start gap-6 bg">
      <Heading
        title="Overview"
        description={`The following
      graph shows the revenue generated by your vehicles each
      month. To individually view each vehicle's revenue, go to the Vehicles tab.`}
      >
        <MdRefresh
          onClick={fetchData}
          className="icon"
          data-tour="general-refresh"
        />
      </Heading>
      <Notification />
      {loading ? (
        <LoadingSpinnerWrapper />
      ) : (
        <Fragment>
          <VehiclesRevenue vehicles={vehicles} showStats={true} />
          {!partner.agreement && (
            <div
              onClick={() => navigate("/settings/agreement")}
              className="text-sm btn-warning animate-pulse lg:w-60"
            >
              Sign FAP Agreement
            </div>
          )}
        </Fragment>
      )}
    </div>
  );
}
